import {isEmpty, isEmptyArray} from "./Helpers";

export const setCookie = (name , value, days  = 1) => {
    const today = new Date();
    today.setTime(today.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + today.toUTCString();
    document.cookie = name + "=" + value+ "; " + expires + "; path=/";
    return true
}

export const getCookie = (search) => {
    return document.cookie.split(';').map((item) => {
        const [name, value] = item.split(/\s?(.*?)=(.*)/).splice(1, 2)
        if(name === search) {
            return value;
        }
    }).filter(item => item !== undefined);
}

export const getCookieValue = (cookieName: string) => {
    let _cookie = getCookie(cookieName);
    if(isEmptyArray(_cookie)) {
        return null;
    }
    let value = decodeURIComponent(_cookie[0] as string)

    if(isEmpty(value)) {
        return null
    }

    return value
}

export function initSetCookie() {
    Array.from(document.querySelectorAll<HTMLElement>('[data-set-cookie]')).forEach(el => {
        const isAnchor = (el instanceof HTMLAnchorElement);

        if (isAnchor) {
            el.addEventListener('click', evt => {
                evt.preventDefault();
                parseAndSetCookie(el);
                if (el.href) window.location.href = el.href;
            });
            return;
        }

        parseAndSetCookie(el);
    });

    const parseAndSetCookie = (el: HTMLElement) => {
        const parts = el.dataset.setCookie?.split(',');
        if (parts && parts.length == 2) setCookie(parts[0], parts[1], 30);
        else console.warn('invalid number of arguments for data-set-cookie on element:', el);
    }
}